import { useCallback, useState } from 'react';

import { NAVIGATION_STEP } from './constants';

const useKeyboardNavigation = ({ flatResults, onSelect, onClose }) => {
  const [selectedIndex, setSelectedIndex] = useState(-1);

  const onKeyDown = useCallback(
    event => {
      switch (event.key) {
        case 'ArrowDown': {
          event.preventDefault();
          setSelectedIndex(prev => {
            const nextIndex = prev + NAVIGATION_STEP;

            return nextIndex >= flatResults.length ? 0 : nextIndex;
          });
          break;
        }

        case 'ArrowUp': {
          event.preventDefault();
          setSelectedIndex(prev => {
            const nextIndex = prev - NAVIGATION_STEP;

            return nextIndex < 0 ? flatResults.length - NAVIGATION_STEP : nextIndex;
          });
          break;
        }

        case 'Enter': {
          event.preventDefault();

          if (selectedIndex >= 0 && selectedIndex < flatResults.length) {
            onSelect(flatResults[selectedIndex]);
          }

          break;
        }

        case 'Escape': {
          event.preventDefault();
          onClose();
          break;
        }

        default:
          break;
      }
    },
    [flatResults, selectedIndex, onSelect, onClose],
  );

  const resetSelection = useCallback(() => {
    setSelectedIndex(-1);
  }, []);

  return {
    selectedIndex,
    setSelectedIndex,
    onKeyDown,
    resetSelection,
  };
};

export default useKeyboardNavigation;
